const { connect } = require("react-redux");
const Snackbar = require("components/Snackbar");
const SnackbarActions = require("../actions/snackbar");

module.exports = connect(
    state => ({
        open: state.snackbar.open,
        message: state.snackbar.message
    }),
    {
        onRequestClose: SnackbarActions.hideSnackbar
    }
)(Snackbar);



// WEBPACK FOOTER //
// ./src/containers/Snackbar.js